import React from 'react';
import MainScreen from './mainScreen';
import { CookiesProvider } from 'react-cookie';
 
export default function Root(props) {
  return (
    <CookiesProvider>
        <MainScreen parent={props}/>
    </CookiesProvider>
  );
}